<template>
    <div class="w-100 cp" data-bs-toggle="modal" data-bs-target="#subscribers">
        <p class="mb-2 text-center text-md-start text-capitalize border-bottom">
          total subscribers
        </p>
        <h5 v-if="count!=null" class="mb-0 text-center text-md-start text-white fw-bold">
            {{count}}
        </h5>
        <h5 v-else class="mb-0 text-center text-md-start text-white fw-bold">
            0
        </h5>
      <div class="modal fade" id="subscribers"  tabindex="-1"  aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div class="modal-content" style="background: #050F1E!important;">
            <div class="modal-header">
              <h5 class="modal-title text-white" id="staticBackdropLabel">Total subscribers</h5>
              <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="d-flex flex-wrap justify-content-center align-items-center gap-2 gap-sm-2">
                <div style="width: 150px" class="card bg-primary  align-items-center justify-content-center text-white">
                  <div>
                    <h5>Google Pay</h5>
                    <h6>{{googlepayCount}}</h6>
                  </div>
                </div>
                <div style="width: 150px" class="card bg-secondary  align-items-center justify-content-center text-white">
                  <div>
                    <h5>Bkash</h5>
                    <h6> {{bkashCount}}</h6>
                  </div>
                </div>
                <div style="width: 150px" class="card bg-light align-items-center justify-content-center text-black">
                  <div>
                    <h4>ShurjoPay</h4>
                    <h5> {{shurjoPayCount}}</h5>
                  </div>
                </div>
                 <div style="width: 150px" class="card bg-light align-items-center justify-content-center text-black">
                  <div>
                    <h5>RedeemCode</h5>
                    <h6> {{redeemCode}}</h6>
                  </div>
                </div>

                <div style="width: 150px" class="card bg-success align-items-center justify-content-center text-white">
                  <div>
                    <h5>Total</h5>
                    <h6> {{count}}</h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data(){
        return{
            count: 0,
          googlepayCount: 0,
          bkashCount: 0,
          shurjoPayCount: 0,
          redeemCode: 0,
        }
    },
  async created(){
    await this.subscribeList();
  },
    methods:{
      async subscribeList() {
        this.isLoading = true;
        const token = localStorage.getItem(this.$tokenKey);
        try {
          const res = await axios.get(
              this.$baseUrl +
              this.$api +
              this.$version1 +
              "/kabbikanalytics/latest-subscribed-user",
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
          );
          this.isLoading = false;
          //console.log(res)
          if (res.status === 200) {
            //console.log(res.data.data)
            this.count = res.data.data.length
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].payment_method === "bKash"){
                this.bkashCount++
              }
              if (res.data.data[i].payment_method === "Googlepay"){
                this.googlepayCount++
              }
              if (res.data.data[i].payment_method === "SurjoPay"){
                this.shurjoPayCount++
              }
              if (res.data.data[i].payment_method === "RedeemCode"){
                this.redeemCode++
              }
            }
          } else {
            this.$vToastify.error("Could not fetch data!");
          }
        } catch (error) {
          console.log(error);
          this.isLoading = false;
        }
      },
    }
}
</script>
